import React, { useState } from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../common-components";

const AgencyItem = ({
  companyName,
  contactNumber,
  email,
  createdOn,
  services,
  onViewClick,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      style={{
        width: "100%",
        height: 50,
        backgroundColor: hover ? colors.greenLight : colors.white,
        display: "flex",
        alignItems: "center",
        fontWeight: "bold",
        fontSize: 10,
        color: hover ? colors.white : "#000000",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.25,
        }}
      >
        <div style={{ marginLeft: 20 }}> {companyName}</div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.15,
        }}
      >
        {contactNumber}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.15,
        }}
      >
        {email}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.1,
        }}
      >
        {createdOn}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.2,
          overflow: "hidden",
        }}
      >
        {services}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: 0.15,
        }}
      >
        <BaseButtons
          label={"VIEW"}
          borderRadius={4}
          backgroundColor={colors.greenDark}
          width={100}
          height={30}
          onClick={onViewClick}
        />
      </div>
    </div>
  );
};

export default AgencyItem;
